import { createRoot } from 'react-dom/client';
import { SoundProvider } from './contexts/SoundContext';
import './index.css';
import App from './App';

createRoot(document.getElementById('root')!).render(
  <SoundProvider>
    <App />
  </SoundProvider>
);
